import {useParams} from "react-router-dom";

type UserProfileRouteParams = {
  userId: string;
};

export const useUserProfileRouteParams = () =>
  useParams<UserProfileRouteParams>();
